import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ce9495"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "notification-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnrecoverableError = _resolveComponent("UnrecoverableError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UnrecoverableError, {
        "message-detail": _ctx.errorMessage,
        onExitTestClicked: _ctx.handleExitTest
      }, null, 8, ["message-detail", "onExitTestClicked"])
    ])
  ]))
}